import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { CAPTCHA_RETRY_SYMBOL } from './CaptchaActions';

export interface CaptchaValue {
  resolve?: (value: string | typeof CAPTCHA_RETRY_SYMBOL) => void;
  reject?: (error: string) => void;
  value: string | null;
}

export interface BaseCaptchaStore {
  value: CaptchaValue;
  isExpired: boolean;
  expiresAt: number | null;
}

export interface BaseCaptchaStoreProps {
  captcha: BaseCaptchaStore;
}

const initialState: BaseCaptchaStore = {
  value: {
    value: null,
  },
  isExpired: false,
  expiresAt: null,
};

export const captchaSlice = createSlice({
  name: 'captcha',
  initialState,
  reducers: {
    setCaptchaPromiseMethods: (
      state,
      action: PayloadAction<{ resolve: (response: string | typeof CAPTCHA_RETRY_SYMBOL) => void; reject: (error: string) => void }>
    ) => {
      state.value.resolve = action.payload.resolve;
      state.value.reject = action.payload.reject;
    },
    setCaptchaValue: (state, action: PayloadAction<string | null>) => {
      state.value.value = action.payload;
    },
    setCaptchaExpired: (state, action: PayloadAction<boolean>) => {
      state.isExpired = action.payload;
    },
    setCaptchaExpiresAt: (state, action: PayloadAction<number | null>) => {
      state.expiresAt = action.payload;
    },
  },
});

export const { setCaptchaPromiseMethods, setCaptchaValue, setCaptchaExpired, setCaptchaExpiresAt } = captchaSlice.actions;

export const captchaReducer = captchaSlice.reducer;
